import { Injectable } from '@angular/core';
import { MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

@Injectable()
export class AndroidAppNavLink extends NavigationLinkBase {
  public allowedStages = MenuStage.INIT;

  constructor() {
    super(
      'ANDROID_APP',
      _('menu.label.validation'),
      _('general.link_to_google_store'),
      _('a11y.link.to_google_store'),
      'STORE_ENTRYS',
      'assets/images/google_play_badge.svg',
    );
  }
}
